module.exports = __webpack_public_path__ + "static/media/10BMCAmuraldetail.6bb98b67.webp";